module.exports = __webpack_public_path__ + "img/web_icon_temp.2b059189.png";